import { liftTarget } from 'prosemirror-transform';
import isListNode from '../utils/isListNode';

export default function clearFormattingCommand(state, editorView) {
  let { tr } = editorView.state;
  const { $from, $to } = tr.selection;

  // remove marks
  Object.entries(state.schema.marks)
    .filter(([key, value]) => value.spec.clearable !== false)
    .forEach(([key, value]) => tr.removeMark($from.pos, $to.pos, state.schema.marks[key]));

  // traverse all nodes within selection recursively and deal with each
  tr.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
    const formattedNodeType = state.schema.nodes[node.type.name];

    if (
      (formattedNodeType && formattedNodeType.name !== 'paragraph') ||
      formattedNodeType.name !== 'text' ||
      // dont want to perform any lift on ordered or bullet lists
      !isListNode(formattedNodeType)
    ) {
      let fromPos = tr.doc.resolve(tr.mapping.map(pos + 1));
      let toPos = tr.doc.resolve(tr.mapping.map(pos + node.nodeSize - 1));
      const nodeRange = fromPos.blockRange(toPos);

      if (nodeRange) {
        const targetLiftDepth = liftTarget(nodeRange);

        if (formattedNodeType.isTextblock) {
          // remove headers
          tr.setNodeMarkup(nodeRange.start, state.schema.nodes.paragraph);
          return false;
        } else if (targetLiftDepth || targetLiftDepth === 0) {
          // remove list_items, links, blockquotes
          tr.lift(nodeRange, targetLiftDepth);
          return false;
        }
      }
    }
  });
  editorView.dispatch(tr);
  return true;
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/plugins/clearFormattingCommand.js